<div class="container" *ngIf="(config$ | async) as config">
  <go-back-button></go-back-button>
  <white-card>
    <form-headers [formHeaders]="config.formHeaders" />
    <form *ngIf="config.formEntries" [formGroup]="form">
      <div *ngFor="let entry of config.formEntries">
        <dynamic-form-item
          [item]="entry"
          [form]="form"
          [previewMode]="true"
          [task]="task"
        ></dynamic-form-item>
      </div>
    </form>
  </white-card>
</div>
